// 诊改报告
export default {
  state: {
    get_zzbg_step: 0, // 当前节点第几步
    get_zzbg_node: {} // 当前节点信息
  },
  mutations: {
    mutations_zzbg_step: (state, a) => {
      state.get_zzbg_step = a
    },
    mutations_zzbg_node: (state, a) => {
      state.get_zzbg_node = a
    }
  },
  actions: {
    set_zzbg_step({
      commit
    }, a) {
      commit('mutations_zzbg_step', a)
    },
    set_zzbg_node({
      commit
    }, a) {
      commit('mutations_zzbg_node', a)
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/zzbg.js